'use client';

import type { ReactNode } from 'react';

import { usePresence } from '../hooks/use-presence';

interface PresenceProviderProps {
  children: ReactNode;
}

/**
 * Provider component that initializes global presence tracking
 *
 * Should be placed high in the component tree (e.g., in the user layout)
 * to ensure presence is tracked across the entire authenticated app.
 *
 * This component:
 * - Connects to the global presence channel on mount
 * - Tracks the current user as online
 * - Updates last_active_at periodically
 * - Cleans up on unmount
 */
export function PresenceProvider({ children }: PresenceProviderProps) {
  // Initialize presence tracking
  usePresence();

  return <>{children}</>;
}
